import React, { useEffect,useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useReportData } from "./useReportData";

import ReportFilterBar from "./ReportFilterBar";
import KpiCards from "./KpiCards";
import AllocationTable from "./AllocationTable";
import FteDonut from "./FteDonut";
import FteByMac from "./FteByMac";
import StatusBreakdown from "./StatusBreakdown";
import ReportSkeleton from "./ReportSkeleton";
import PageInfo from "../../../../../components/common/PageInfo";


import { exportMonthlyReport } from "../../../../../api/reports/reports";

const MONTH_NAMES = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec"
];

const Reports = ({ macIdFilter = null }) => {
  const theme = useTheme();
  const t = theme.custom;

  const {
    year,
    month,
    navigateMonth,
    macs,
    associates,
    selectedMacIds,
    setSelectedMacIds,
    selectedAssociateIds,
    setSelectedAssociateIds,
    selectedStatuses,
    setSelectedStatuses,
    selectedFteValues,
    setSelectedFteValues,
    fetchReport,
    reset,
    reportData,
    loading,
    error,
  } = useReportData();

  // If a macIdFilter is passed (MAC Leader), lock the filter to that MAC only
useEffect(() => {
  if (macIdFilter && macs.length > 0) {
    const matched = macs.find(m => m.id === macIdFilter || m.macId === macIdFilter);
    if (matched) {
      setSelectedMacIds([matched.id ?? matched.macId]);
    }
  }
}, [macIdFilter, macs]);

  const monthLabel = `${MONTH_NAMES[month - 1]} ${year}`;

  const handleReset = () => {
    reset();
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchReport();
    }, 400);

    return () => clearTimeout(timeout);
  }, [
    year,
    month,
    selectedMacIds,
    selectedAssociateIds,
    selectedStatuses,
    selectedFteValues
  ]);

  return (

    
    <div style={containerStyle(t)}>

      

      {/* ───── FILTER ───── */}
      <ReportFilterBar
        year={year}
        month={month}
        navigateMonth={navigateMonth}
        macs={macs}
        associates={associates}
        selectedMacIds={selectedMacIds}
        setSelectedMacIds={setSelectedMacIds}
        setSelectedMacIds={macIdFilter ? undefined : setSelectedMacIds}
        selectedAssociateIds={selectedAssociateIds}
        setSelectedAssociateIds={setSelectedAssociateIds}
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
        selectedFteValues={selectedFteValues}
        setSelectedFteValues={setSelectedFteValues}
        onReset={handleReset}
        rows={reportData?.allocations || []}
        hideMacFilter={!!macIdFilter}
        hideExportButton={false}
      />

      <PageInfo message="View and Manage your reports"/>

      {/* ───── LOADING ───── */}
      {loading && <ReportSkeleton />}

      {/* ───── DATA ───── */}
{!loading && !error && reportData && (
  <>
    {/* ───── TABLE ROW ───── */}
    <div style={tableRow}>
      <AllocationTable
        allocations={reportData.allocations || []}
      />
    </div>

    {/* ───── CHART ROW ───── */}
    {/* <div style={chartRow}>
      <FteDonut
        fteDistribution={reportData.charts?.fteDistribution}
        monthLabel={monthLabel}
      />

      <StatusBreakdown
        statusBreakdown={reportData.charts?.statusBreakdown}
        totalAllocations={reportData.metrics?.totalAllocations}
      />

      <FteByMac
        fteByMac={reportData.charts?.fteByMac}
      />
    </div> */}

    {/* ───── KPI ROW ─────
    <div style={kpiRow}>
      <KpiCards metrics={reportData.metrics} />
    </div> */}
  </>
)}
    </div>
  );
};

export default Reports;


/* ───────────────────────── STYLES ───────────────────────── */
/* ───────────────────────── STYLES ───────────────────────── */

const containerStyle = (t) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflowY: "auto",
  padding: 24,
  boxSizing: "border-box",
  background: t.bg,
  gap: 16,
});


/* ✅ KPI → auto-fit (FIXES spacing issue) */
const kpiRow = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 16,
};


/* ✅ Charts → responsive grid */
const chartRow = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: 16,
  alignItems: "stretch",
};


/* ✅ Table → full width + scroll safety */
const tableRow = {
  width: "100%",
  minWidth: 0,   // ✅ VERY IMPORTANT (fixes grid overflow issues)
};

/* ───────────────────────── ERROR UI ───────────────────────── */

const ErrorBox = ({ error }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "12px 16px",
        borderRadius: 8,
        fontSize: 13,
        background: "rgba(226,75,74,0.08)",
        color: "#E24B4A",
        border: "1px solid rgba(226,75,74,0.2)",
      }}
    >
      <span>⚠</span> {error}
    </div>
  );
};